import script from "./Fase2Recepcion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Fase2Recepcion.vue?vue&type=script&setup=true&lang=ts"

import "./Fase2Recepcion.vue?vue&type=style&index=0&id=54e96930&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e96930"]])

export default __exports__